<template>
  <StatusChangeProcedureApplyInput label="跟读转正"
                                   class="status-change-procedure-apply-roll-state"
                                   v-on="$listeners"
                                   :resolve-form="getApplyInfo">
    <template>
      <slot></slot>
    </template>
    <template #form>
      <el-form size="mini"
               label-width="120px"
               label-suffix="：">
        <el-form-item label="准考证号">
          <el-input v-model.trim="form.admissionNo"
                    type="text"
                    maxlength="50"
                    placeholder="请填写准考证号"></el-input>
        </el-form-item>
        <el-form-item label="转入班级">
          <ClazzPicker v-model="form.targetClassId"></ClazzPicker>
        </el-form-item>
        <el-form-item v-if="form.targetClassId">
          <StudentCourseDockPanel ref="dock"
                                  :student-id="studentId"
                                  :clazz-id="form.targetClassId"></StudentCourseDockPanel>
        </el-form-item>
        <el-form-item label="修改后的学号">
          <el-input v-model.trim="form.targetRegNo"
                    type="text"
                    maxlength="50"
                    placeholder="请填写学号"></el-input>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input v-model="form.remark"
                    type="textarea"
                    maxlength="200"></el-input>
        </el-form-item>
      </el-form>
    </template>
  </StatusChangeProcedureApplyInput>
</template>

<script>
import StatusChangeProcedureApplyInput from '../input'
import ClazzPicker from '../../../../../../../../biz/picker/clazz'
import StudentCourseDockPanel from '../../../../../wrapper/panel/student/course/dock'
export default {
  name: 'StatusChangeProcedureApplyRollState',
  components: {
    StatusChangeProcedureApplyInput,
    ClazzPicker,
    StudentCourseDockPanel
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      form: {
        admissionNo: '',
        targetClassId: '',
        targetRegNo: '',
        remark: ''
      }
    }
  },
  methods: {
    getApplyInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.admissionNo) {
          reject(new Error('请填写准考证号'))
          return
        }
        if (!this.form.targetClassId) {
          reject(new Error('请选择转入班级'))
          return
        }
        if (!this.form.targetRegNo) {
          reject(new Error('请填写学号'))
          return
        }
        if (!this.form.remark) {
          this.$confirm('未填写备注信息，确认继续吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleApply(this.form, resolve, reject)
          }).catch(() => {})
        } else {
          this.handleApply(this.form, resolve, reject)
        }
      })
    },
    handleApply (form, resolve, reject) {
      this.$nextTick(() => {
        const dock = this.$refs.dock
        const promise = dock ? dock.getDockInfo() : Promise.resolve()
        promise.then(result => {
          resolve({
            url: '/workspace/manager/status/change/procedure/rollState/submitApply',
            data: this.$qs.stringify(this.$extend({
              postId: this.studentId
            }, form, this.extraParams, result))
          })
        }).catch(err => reject(err))
      })
    }
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          if (typeof this.form[key] === 'string') {
            this.form[key] = val[key] || ''
          } else {
            this.form[key] = val[key]
          }
        })
      }
    }
  }
}
</script>
